<template>
  <div class="intro-step">
    <h1 class="ls-title-1 ls-color-theme ls-lg-margin-bottom">{{ $t('wizard.welcome') }}</h1>
    <h2 class="ls-title-5 ls-lg-margin-bottom">{{ $t('wizard.initial_configs') }}</h2>
    <router-link :to="{ name: 'steps'}" :title="$t('wizard.btn_lets_start')" class="ls-btn-primary">{{ $t('wizard.btn_lets_start') }}</router-link>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Wizard',
    data () {
      return {
        error: false
      }
    },
    computed: {
      ...mapGetters(['seller']),
      showWizard () {
        return false
      }
    },
    mounted () {
      if (!this.showWizard) {
        this.$router.push('/contracts')
      }
    }
  }
</script>
<style lang="scss">
  .intro-step {
    text-align: center;
    width: 100%;
    vertical-align: middle;
    position: relative;
    margin-top: 120px;
  }
  /*.ls-main-full .container-fluid {
    height: calc(100vh - 120px)
  }*/
</style>



// WEBPACK FOOTER //
// Main.vue?d3c73100